
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faStar, faUsers, faXmark } from '@fortawesome/free-solid-svg-icons'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { Link } from "react-router-dom"
import Select from "react-select";

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function CopyCard({ trade_id, image, photo, name, winrate, profit, win, loss, copy, price, info, pending, badge_color }) {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [modalIsOpen2, setIsOpen2] = useState(false);
    const [modalIsOpen3, setIsOpen3] = useState(false);
    const [modalIsOpen4, setIsOpen4] = useState(false);
    const [disable, setDisable] = useState(true);
    const [disable1, setDisable1] = useState(true);
    const { user } = useUser();
    const [copied, setCopied] = useState(copy);
    const [pend, setPending] = useState(pending);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const badgeoption = [
      { value: 'blue', label: 'Blue' },
      { value: 'gold', label: 'Gold' }
    ];
    const [trader_photo, setTrader_photo] = useState(photo);
    const [trader_name, setTrader_name] = useState(name);
    const [ewin, setWin] = useState(win);
    const [eloss, setLoss] = useState(loss);
    const [win_rate, setWin_rate] = useState(winrate);
    const [profit_share, setProfit_share] = useState(profit);
    const [eprice, setPrice] = useState(price);
    const [aum, setAum] = useState(info.aum);
    const [copiers, setCopiers] = useState(info.current_copiers);
    const [mock, setMock] = useState(info.mock_copiers);
    const [totalCopiers, setTotalCopiers] = useState(info.total_copiers);
    const [pnl, setPnl] = useState(info.copiers_profit);
    const [margin, setMargin] = useState(info.margin_balance);
    const [lock, setLock] = useState(info.lock_period);
    const [min, setMin] = useState(info.min_amount);
    const [ninetyRatio, setNinetyRatio] = useState(info['ninety']?.ratio);
    const [sevenRatio, setSevenRatio] = useState(info['seven']?.ratio);
    const [thirtyRatio, setThirtyRatio] = useState(info['thirty']?.ratio);
    const [ninetyPnl, setNinetyPnl] = useState(info['ninety']?.pnl);
    const [sevenPnl, setSevenPnl] = useState(info['seven']?.pnl);
    const [thirtyPnl, setThirtyPnl] = useState(info['thirty']?.pnl);
    const [ninetyRoi, setNinetyRoi] = useState(info['ninety']?.roi);
    const [sevenRoi, setSevenRoi] = useState(info['seven']?.roi);
    const [thirtyRoi, setThirtyRoi] = useState(info['thirty']?.roi);
    const [ninetyProfit, setNinetyProfit] = useState(info['ninety']?.profit_position);
    const [sevenProfit, setSevenProfit] = useState(info['seven']?.profit_position);
    const [thirtyProfit, setThirtyProfit] = useState(info['thirty']?.profit_position);
    const [ninetyPosition, setNinetyPosition] = useState(info['ninety']?.total_position);
    const [sevenPosition, setSevenPosition] = useState(info['seven']?.total_position);
    const [thirtyPosition, setThirtyPosition] = useState(info['thirty']?.total_position);
    const [ninetyMdd, setNinetyMdd] = useState(info['ninety']?.mdd);
    const [sevenMdd, setSevenMdd] = useState(info['seven']?.mdd);
    const [thirtyMdd, setThirtyMdd] = useState(info['thirty']?.mdd);
    const [ninetyWinRate, setNinetyWinRate] = useState(info['ninety']?.win_rate);
    const [sevenWinRate, setSevenWinRate] = useState(info['seven']?.win_rate);
    const [thirtyWinRate, setThirtyWinRate] = useState(info['thirty']?.win_rate);
    const [description, setDescription] = useState(info.desc);
    const [rank, setRank] = useState(info.rank);
    const [portfolio, setPortfolio] = useState(info.closed_portfolio);
    const [join, setJoin] = useState(info.join_days);
    const [files, setFiles] = useState([]);
    const [ebadge_color, setBadge_color] = useState(badge_color);
    const ValidateCopy = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_copy: true, trade_id: trade_id, price: price, copied : !copied })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            if(copied == false){
              setPending(true);
              setCopied(!copied);
            }else{
              setCopied(!copied);
            }
          }else{
            toast.error(data.message);
            setLoading(false);
          }
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
        })
    }
    useEffect(() => {
      if(trader_photo && trader_name && ewin && eloss && win_rate && profit_share && eprice && ebadge_color && description && aum && copiers && join){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [trader_photo, trader_name, ewin, eloss, win_rate, profit_share, eprice, ebadge_color, description, aum, copiers, join]);
    useEffect(() => {
      if(mock && totalCopiers && min && ninetyRatio && lock && margin && pnl && sevenRatio && thirtyRatio && ninetyPnl && sevenPnl && thirtyPnl && ninetyRoi && sevenRoi && thirtyRoi && ninetyProfit && sevenProfit && thirtyProfit && ninetyPosition && sevenPosition && thirtyPosition && ninetyMdd && sevenMdd && thirtyMdd && ninetyWinRate && sevenWinRate && thirtyWinRate && rank && portfolio){
        setDisable1(false);
      }else{
        setDisable1(true);
      }
    }, [mock, totalCopiers, min, ninetyRatio, lock, margin, pnl, sevenRatio, thirtyRatio, ninetyPnl, sevenPnl, thirtyPnl, ninetyRoi, sevenRoi, thirtyRoi, ninetyProfit, sevenProfit, thirtyProfit, ninetyPosition, sevenPosition, thirtyPosition, ninetyMdd, sevenMdd, thirtyMdd, ninetyWinRate, sevenWinRate, thirtyWinRate, rank, portfolio]);
    const EditCopyTrade = () =>{
      setLoading1(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_editcopytrade: true, trade_id : trade_id, trader_photo : trader_photo, trader_name : trader_name, win : ewin, loss : eloss, win_rate : win_rate, profit_share : profit_share, price : eprice, badge_color: ebadge_color, description: description, aum: aum, copiers: copiers, join: join, mock: mock, totalCopiers: totalCopiers, min: min, lock: lock, margin: margin, pnl: pnl, ninetyRatio: ninetyRatio, sevenRatio: sevenRatio, thirtyRatio: thirtyRatio, ninetyPnl: ninetyPnl, sevenPnl: sevenPnl, thirtyPnl: thirtyPnl, ninetyRoi: ninetyRoi, sevenRoi: sevenRoi, thirtyRoi: thirtyRoi, ninetyProfit: ninetyProfit, sevenProfit: sevenProfit, thirtyProfit: thirtyProfit, ninetyPosition: ninetyPosition, sevenPosition: sevenPosition, thirtyPosition: thirtyPosition, ninetyMdd: ninetyMdd, sevenMdd: sevenMdd, thirtyMdd: thirtyMdd, ninetyWinRate: ninetyWinRate, sevenWinRate: sevenWinRate, thirtyWinRate: thirtyWinRate, rank: rank, portfolio: portfolio})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "copyexpert";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading1(false);
      })
      .catch(err => {
        console.error(err)
        setLoading1(false);
      })
    }
    const DeleteCopyTrade = () =>{
      setLoading2(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deletecopytrade: true, trade_id : trade_id})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "copyexpert";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading2(false);
      })
      .catch(err => {
        console.error(err)
        setLoading2(false);
      })
    }
    const darkThemeStyles = {
      control: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        border: "none",
        color: "#fff",
        minWidth: "135px"
      }),
      menu: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
      }),
      option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
        color: "#fff",
      }),
      singleValue: (styles) => ({
        ...styles,
        color: "#fff",
      }),
    };
    return (
      <div className="mycard p-3 mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-center rounded-2 overflow-hidden" style={{height:'40px',width:'40px'}}>
              {image}
            </div>
            <div className="ms-2">
              <p className="mb-0 fw-bold">{name}</p>
              <div className="d-flex align-items-center">
                <p className="mb-0 rounded-2 py-0 px-1 text-secondary fw-bold d-inline-block" style={{backgroundColor:'#ffffff0c', fontSize:'14px'}}>
                  <FontAwesomeIcon icon={faUsers} style={{fontSize: '14px'}} /> {info ? info.current_copiers : '100/500'}</p>
                <p className="mb-0 rounded-2 py-0 px-1 text-secondary fw-bold d-inline-block ms-1" style={{backgroundColor:'#ffffff0c', fontSize:'14px'}}>API</p>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div className="position-relative rounded-circle" style={{backgroundColor: 'white', height:'13px',width:'13px'}}>
              <img src={`/uploads/${badge_color === "gold" ? "goldtick.png" : "bluetick.png"}`} alt="badge" width="20px" className="position-absolute" style={{left: '-2px',top:'-3px'}} />
            </div>
            {user?.user_type === "adminface" && (
              <p className="text-prime fw-semibold ms-3 mb-0" onClick={() => setIsOpen3(true)} style={{cursor: 'pointer', fontSize:'14px'}}>Edit</p>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div>
            <p className="mb-0 text-secondary lh-1" style={{fontSize:'14px'}}>Profit Share</p>
            <p className="mb-0 text-success fw-bold" style={{fontSize:'22px'}}>{profit}%</p>
            <p className="mb-0 text-secondary lh-1" style={{fontSize:'14px'}}>Win Rate <span className="text-success">{winrate}%</span></p>
          </div>
          <div style={{width:'40%'}}>
            <img src="uploads/chartline.png" alt="logo" className="mb-4" style={{width:'100%'}}/>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Copy Price</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>AUM (USDT)</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{info ? formatCurrency(info.aum) : '--'}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>No. Win</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{win ? win : '--'}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>No. Loss</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{loss ? loss : '--'}</p>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          {(pend && copied) ? (
            <div className={`myBtn text-center text-uppercase fw-bold bg-secondary w-100`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={() => setIsOpen(true)}>Pending</div>
          ) : (
            <>
              <Link to="/copyprofile" state={{trade_id : trade_id}} className={`myBtn bg-secondary text-center text-uppercase fw-bold`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px',width: '30%',}}>View</Link>
              <div className={`myBtn ${copied?'bg-danger':'bg-prime'} text-center text-uppercase fw-bold`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px',width: '67%',}} onClick={() => {copied ? setIsOpen2(true) : setIsOpen1(true) }}>{copied?'Copied':'Copy'}</div>
            </>
          )}
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white text-prime text-center w-100 text-uppercase" style={{fontSize: '14px'}}>Information</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <p className="text-center fw-bold mx-lg-5 mt-3" style={{fontSize:'20px'}}>Your request to copy this trade is currently under approval.</p>
          <div className={`myBtn text-center text-uppercase fw-bold bg-prime w-100 mt-3`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={() => setIsOpen(false)}>OK</div>
        </Modal>
        <Modal
          isOpen={modalIsOpen1}
          onRequestClose={() => setIsOpen1(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white text-prime text-center w-100 text-uppercase" style={{fontSize: '14px'}}>Copy Trade</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
          </div>
          <p className="fw-bold mt-3 mb-0" style={{fontSize:'20px'}}>Copy Trader - {name}</p>
          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>You are about to copy the above trader at a price of <span className="fw-bold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</span></p>
          <div className={`myBtn bg-success text-center text-uppercase w-100 fw-bold mt-3`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={ValidateCopy}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Copy'}</div>
        </Modal>
        <Modal
          isOpen={modalIsOpen2}
          onRequestClose={() => setIsOpen2(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white text-prime text-center w-100 text-uppercase" style={{fontSize: '14px'}}>Uncopy Trade</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
          </div>
          <p className="fw-bold mt-3 mb-0" style={{fontSize:'20px'}}>Copy Trader - {name}</p>
          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>You are currently copying this trader at a price of <span className="fw-bold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</span>. If you wish to stop copying, click "Uncopy" below. </p>
          <div className={`myBtn bg-danger text-center text-uppercase w-100 fw-bold mt-3`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={ValidateCopy}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Uncopy'}</div>
        </Modal>
        <Modal
            isOpen={modalIsOpen3}
            onRequestClose={() => setIsOpen3(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Edit expert</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen3(false)} />
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Expert image</label>
            <FilePond
              files={files}
              onupdatefiles={setFiles}
              allowMultiple={false}
              maxFiles={3}
              name="file"
              labelIdle="Click here to upload payment proof"
              server={{
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                  const formData = new FormData();
                  formData.append("file", file);
                  const request = new XMLHttpRequest();
                  request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    const res = JSON.parse(request.responseText);
                    if (res.success) {
                      setTrader_photo(res.filename);
                      load(res.filename);
                    } else {
                      error(res.error || "Upload failed");
                    }
                  };
                  request.onerror = () => {
                    error("Upload error");
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    }
                  };
                },
                revert: (serverId, load, error) => {
                  fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filename: trader_photo })
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.success) {
                        setTrader_photo("");
                        setFiles([]);
                        load();
                      } else {
                        error(data.error || "Failed to delete file");
                      }
                    })
                    .catch(() => {
                      error("Delete request failed");
                    });
                }
              }}
            />
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Expert Name:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder="Gunbot"
                  className="inputNone"
                  value={trader_name}
                  onChange={(e) => setTrader_name(e.target.value)}
                />
            </div>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Description:</label>
            <div className="form-control py-2">
                <textarea 
                  type="text"
                  className="inputNone w-100"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={2}
                />
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Win:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={ewin}
                      onChange={(e) => setWin(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    WIN
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Loss:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={eloss}
                      onChange={(e) => setLoss(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    LOSS
                    </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Win Rate:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="40"
                      className="inputNone"
                      value={win_rate}
                      onChange={(e) => setWin_rate(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      %
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Profit Share:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="2"
                      className="inputNone"
                      value={profit_share}
                      onChange={(e) => setProfit_share(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      %
                    </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Join Days:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="365"
                      className="inputNone"
                      value={join}
                      onChange={(e) => setJoin(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      Days
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Copiers:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="text"
                      placeholder="100/1000"
                      className="inputNone"
                      value={copiers}
                      onChange={(e) => setCopiers(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>AUM (USDT):</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      className="inputNone"
                      value={aum}
                      onChange={(e) => setAum(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      USDT
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Price:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      className="inputNone"
                      value={eprice}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      USD
                    </div>
                </div>
              </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Badge:</label>
            <Select 
                options={badgeoption} 
                value={badgeoption.find((opt) => opt.value === ebadge_color)}
                onChange={(selected) => {
                  setBadge_color(selected.value); 
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
            <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
              <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteCopyTrade}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
              <div
                className={`myBtn w-100 text-center mt-3 ${disable ? 'disabled' : ''}`}
                style={{ paddingTop: '12px', paddingBottom: '12px' }}
                onClick={() => {if (disable) return; setIsOpen3(false);setIsOpen4(true);}}>
                Next
              </div>
            </div>
        </Modal>
        <Modal
            isOpen={modalIsOpen4}
            onRequestClose={() => setIsOpen4(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Add expert</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen4(false)} />
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Rank:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1"
                      className="inputNone"
                      value={rank}
                      onChange={(e) => setRank(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Closed Portfolios:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={portfolio}
                      onChange={(e) => setPortfolio(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Mock Copiers:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="500"
                      className="inputNone"
                      value={mock}
                      onChange={(e) => setMock(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Total Copiers:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={totalCopiers}
                      onChange={(e) => setTotalCopiers(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Margin Balance:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder=""
                      className="inputNone"
                      value={margin}
                      onChange={(e) => setMargin(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Copiers PnL(USDT):</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={pnl}
                      onChange={(e) => setPnl(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Lock Period:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="text"
                      placeholder="30D"
                      className="inputNone"
                      value={lock}
                      onChange={(e) => setLock(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Min. Copy Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="text"
                      placeholder="10/10"
                      className="inputNone"
                      value={min}
                      onChange={(e) => setMin(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Performance:</label>
            <div className="d-flex align-items-center justify-content-between">
              <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>7D</label>
              <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>30D</label>
              <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>90D</label>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>ROI:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={sevenRoi}
                      onChange={(e) => setSevenRoi(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={thirtyRoi}
                      onChange={(e) => setThirtyRoi(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={ninetyRoi}
                      onChange={(e) => setNinetyRoi(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>PnL (USDT):</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={sevenPnl}
                      onChange={(e) => setSevenPnl(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={thirtyPnl}
                      onChange={(e) => setThirtyPnl(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={ninetyPnl}
                      onChange={(e) => setNinetyPnl(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Sharpe Ratio:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={sevenRatio}
                      onChange={(e) => setSevenRatio(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={thirtyRatio}
                      onChange={(e) => setThirtyRatio(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={ninetyRatio}
                      onChange={(e) => setNinetyRatio(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Win Rate:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={sevenWinRate}
                      onChange={(e) => setSevenWinRate(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={thirtyWinRate}
                      onChange={(e) => setThirtyWinRate(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={ninetyWinRate}
                      onChange={(e) => setNinetyWinRate(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>MDD:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={sevenMdd}
                      onChange={(e) => setSevenMdd(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={thirtyMdd}
                      onChange={(e) => setThirtyMdd(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={ninetyMdd}
                      onChange={(e) => setNinetyMdd(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Total Positions:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="7"
                      className="inputNone"
                      value={sevenPosition}
                      onChange={(e) => setSevenPosition(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="7"
                      className="inputNone"
                      value={thirtyPosition}
                      onChange={(e) => setThirtyPosition(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="7"
                      className="inputNone"
                      value={ninetyPosition}
                      onChange={(e) => setNinetyPosition(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Profitable Positions:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="4"
                      className="inputNone"
                      value={sevenProfit}
                      onChange={(e) => setSevenProfit(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="4"
                      className="inputNone"
                      value={thirtyProfit}
                      onChange={(e) => setThirtyProfit(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="4"
                      className="inputNone"
                      value={ninetyProfit}
                      onChange={(e) => setNinetyProfit(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
              <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteCopyTrade}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
              <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? EditCopyTrade : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
            </div>
        </Modal>
      </div>
    )
  }
  
  export default CopyCard